import { useTranslation } from 'react-i18next';
import { Typography } from '@/UI/AppTypography/AppTypography';
import { FlexCenHorVer } from '@/UI/styles';
import { I18N_KEYS } from '@/language/keys';
import { GiftIcon } from '@/UI/Icons/GiftIcon';

export const HolidayPromoBanner = () => {
  const { t } = useTranslation();
  return (
    <FlexCenHorVer
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 1.25, sm: 0 },
        alignItems: 'center',
        width: '100%',
      }}
    >
      {/* title */}
      <Typography sx={{ color: '#101012', display: 'flex', alignItems: 'center', fontWeight: 600 }}>
        <GiftIcon />
        &nbsp; &nbsp;{t(I18N_KEYS.WEAVY_MARKETING.APP_BANNER.HOLIDAY_PROMO.TITLE)}
      </Typography>
      <Typography
        sx={{
          color: '#101012',
          ml: { xs: 0, sm: '0.25rem' },
          mt: { xs: 0, sm: 0 },
        }}
      >
        &nbsp; &nbsp;{t(I18N_KEYS.WEAVY_MARKETING.APP_BANNER.HOLIDAY_PROMO.SUBTITLE)}
      </Typography>
    </FlexCenHorVer>
  );
};
